import { useState, useMemo, useEffect } from "react";

export const usePagination = (data, searchKeys = [], defaultPageSize = 10) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, pageSize]);

  const filteredData = useMemo(() => {
    if (!searchTerm) return data;
    
    if (typeof searchKeys === 'function') {
        return data.filter(item => searchKeys(item, searchTerm));
    }

    const lowerSearch = searchTerm.toLowerCase();
    return data.filter((item) => {
      return searchKeys.some((key) => {
        const value = key.split('.').reduce((o, i) => (o ? o[i] : null), item);
        if (value && typeof value === 'string') {
          return value.toLowerCase().includes(lowerSearch);
        }
        if (value && typeof value === 'number') {
          return value.toString().includes(lowerSearch);
        }
        return false;
      });
    });
  }, [data, searchTerm, searchKeys]);

  const totalItems = filteredData.length;
  const totalPages = Math.ceil(totalItems / pageSize);

  useEffect(() => {
    if (currentPage > totalPages && totalPages > 0) {
      setCurrentPage(totalPages);
    } else if (totalPages === 0 && currentPage !== 1) {
      setCurrentPage(1);
    }
  }, [totalPages, currentPage]);

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return filteredData.slice(startIndex, startIndex + pageSize);
  }, [filteredData, currentPage, pageSize]);

  return {
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
    searchTerm,
    setSearchTerm,
    filteredData,
    paginatedData,
    totalItems,
    totalPages,
  };
};
